/**
 * Auth store using Zustand
 * Manages authentication state globally without Context providers
 */

import type { UserPublic } from '@dovydaskukalis/shared/types/api/users/schemas';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthStore {
  user: UserPublic | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  hasWorkspace: boolean;
  login: (accessToken: string, refreshToken: string, user: UserPublic) => void;
  logout: () => void;
  setAuthState: (accessToken: string, refreshToken: string, user: UserPublic) => void;
  setHasWorkspace: (hasWorkspace: boolean) => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      isLoading: false,
      hasWorkspace: false,

      login: (accessToken, refreshToken, user) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        set({ user, accessToken, refreshToken, isAuthenticated: true, hasWorkspace: false });
      },

      logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
          hasWorkspace: false,
        });
      },

      setAuthState: (accessToken, refreshToken, user) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        set({ user, accessToken, refreshToken, isAuthenticated: true });
      },

      setHasWorkspace: (hasWorkspace) => {
        set({ hasWorkspace });
      },
    }),
    {
      name: 'auth-storage',
    },
  ),
);
